
import {
  defineComponent, ref, onMounted, watch, onBeforeUnmount,
} from 'vue';
import { Pagination, Select, message, } from 'ant-design-vue';
import { getRequest, } from '@/request/request';
import axios from 'axios';

import EZUIKit from 'ezuikit-js';
import { serverIp, } from '@/configs';

const { Option, } = Select;

export default defineComponent({
  components: {
    Pagination,
    Select,
    Option,
  },
  setup () {
    const btnInfo = [
      { value: 1, label: '1幅', }, { value: 4, label: '4幅', },
    ];
    const decBtns = [0,
      6,
      3,
      7,
      1,
      5,
      2,
      4,];
    // 播放器
    const players = Array(9).fill(null);
    let dom: any = null;
    // 是否为操作页面
    const isSelected = ref<boolean>(false);
    // 分页
    const pageSize = ref<number>(1);
    const currentPage = ref<number>(1);
    // 当前显示的摄像头信息
    const showVideos = ref<any[]>([]);
    // 所有摄像头信息
    const videos = ref<any[]>([]);
    // 当前选中通道
    const curChannel = ref<string>('all');

    // 云台控制
    const clickedNum = ref<number>(-1);

    // 萤石云关键信息
    const keyInfo = {
      appKey: '',
      appSecret: '',
      accessToken: '',
    };

    // 切换按钮
    const changeNum = (val: any): void => {
      pageSize.value = val;
      currentPage.value = 1;
      const startIndex = 0;
      const endIndex = val;

      // 展示所需摄像头数组
      showVideos.value = videos.value.slice(startIndex, endIndex);
    };

    // 翻页
    const onChange = (currentPageNum: number, currentPageSize?: number): void => {
      currentPage.value = currentPageNum;
      const startIndex = (currentPageNum - 1) * pageSize.value;
      const endIndex = currentPageNum * pageSize.value;

      isSelected.value = false;

      // 展示所需摄像头数组
      showVideos.value = videos.value.slice(startIndex, endIndex);
    };

    // 通道切换
    const selectChange = (val: any) => {
      if (val === 'all') {
        isSelected.value = false;
        changeNum(1);
      } else {
        isSelected.value = true;
        pageSize.value = 1;
        const curVideo = videos.value.filter((item: any) => item.url === val);

        showVideos.value = curVideo;
      }
    };

    const getData = async (chimneyNo: string) => {
      // 获取基本信息及通道
      const deviceSerial = chimneyNo || '';
      const res = await getRequest('/gaochun/airMap/getCameraUrl', {
        deviceSerial,
      });
      const { deviceList, appKey, secret, } = res.data || {};

      keyInfo.appKey = appKey;
      keyInfo.appSecret = secret;
      videos.value = deviceList ? JSON.parse(deviceList) : [];

      // 获取token
      const resTmp:any = await axios.post(`${serverIp}/camera/getToken`, {
        appKey,
        appSecret: secret,
      });

      keyInfo.accessToken = resTmp.data;
      showVideos.value = videos.value.slice(0, 1);
    };

    const clearPlayers = () => {
      players.forEach((item, index) => {
        if (players[index]) {
          players[index].stop();
        }
        players[index] = null;
      });
    };
    // 初始化播放器
    const initPlayer = (arr: any[]) => {
      const { length, } = arr;

      clearPlayers();
      if (!arr || arr.length < 0) {
        return;
      }
      let html = '';

      arr.forEach((item, index) => {
        if (item) {
          html += `<div class="items-item"><div id="fire-video${index}" style="width:100%;height:100%"></div></div>`;
        } else {
          html += `<div class="items-item"><div id="fire-video-empty" style="width:100%;height:100%;background:#000"></div></div>`;
        }
      });
      html = `<div class='items items-${length}'>${html}</div>`;
      dom.innerHTML = html;
      arr.forEach((item, index) => {
        // 初始化声明
        if (!item) {
          return;
        }
        players[index] = new EZUIKit.EZUIKitPlayer({
          id: `fire-video${index}`,
          accessToken: keyInfo.accessToken,
          url: item,
          template: 'standard',
          audio: 0,
        });
      });
    };

    // 播放
    const playVideo = (videosInfo: any[]) => {
      const len = videosInfo.length;
      let tmpLen = pageSize.value - len;
      const codes = [];

      videosInfo.forEach((item: any) => {
        codes.push(item.url);
      });
      // 传入空数据，保证1、4、9画面
      while (tmpLen > 0) {
        codes.push('');
        tmpLen--;
      }
      initPlayer(codes);
    };

    // 云台控制接口
    const operationCamera = async (params:any) => {
      // 开启
      const res = await axios({
        method: 'post',
        url: 'https://open.ys7.com/api/lapp/device/ptz/start',
        params,
        headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
      });

      if (res.data.code === '200') {
        // 暂停
        await axios({
          method: 'post',
          url: 'https://open.ys7.com/api/lapp/device/ptz/stop',
          params,
          headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
        });
      } else if (res.data.msg) {
        message.error(res.data.msg);
      }

      return true;
    };

    // 云台控制
    const videoControl = async (direction: number) => {
      clickedNum.value = direction;
      const { deviceSerial, channelNo, } = showVideos.value[0];
      const { accessToken, } = keyInfo;
      const param = {
        accessToken,
        deviceSerial,
        channelNo,
        direction,
        speed: '1',
      };

      await operationCamera(param);
      clickedNum.value = -1;
    };

    // 父组件赋值
    const setParamData = (val:any) => {
      pageSize.value = 1;
      currentPage.value = 1;
      videos.value = [];
      curChannel.value = 'all';
      isSelected.value = false;
      getData(val);
    };

    watch(
      () => showVideos.value,
      (val) => {
        playVideo(val);
      },
      {
        flush: 'post',
      }
    );

    onMounted(() => {
      dom = document.getElementById('players-box');
    });

    onBeforeUnmount(() => {
      clearPlayers();
    });

    return {
      changeNum,
      onChange,
      setParamData,
      pageSize,
      currentPage,
      btnInfo,
      videos,
      isSelected,
      curChannel,
      showVideos,
      selectChange,
      decBtns,
      clickedNum,
      videoControl,
      clearPlayers,
    };
  },
});
